import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

/**
 * Use the side effects middleware to capture a specific action and do some other
 * tangential function. E.g. tracking
 */
import * as Actions from './actions';
/* eslint-disable no-case-declarations */

export default (function (AbSDK, res) {
  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);

        switch (action.type) {
          case Actions.ACTIVATE_EXPERIMENT:
          case Actions.DEACTIVATE_EXPERIMENT:
            var currentlyActiveExperiments = store.getState().experiments.currentlyActiveExperiments;
            var variantIds = Object.keys(currentlyActiveExperiments).map(function (id) {
              return currentlyActiveExperiments[id].variantID;
            }); // Filter any null or 0 variant Ids

            variantIds = variantIds.filter(function (id) {
              return id;
            });
            AbSDK.setActiveVariants(variantIds, res);
            break;

          default:
            break;
        }

        return result;
      };
    };
  };
});
/* eslint-enable no-case-declarations */